/**
 * Utility functions for managing page meta tags
 */

export const updateMetaTags = (description, title = "Hamazon | המזון") => {
  // Update title
  document.title = title;

  // Update or create description meta tag
  let descriptionTag = document.querySelector('meta[name="description"]');
  if (!descriptionTag) {
    descriptionTag = document.createElement("meta");
    descriptionTag.name = "description";
    document.head.appendChild(descriptionTag);
  }
  descriptionTag.content = description;

  // Update or create og:description meta tag
  let ogDescTag = document.querySelector('meta[property="og:description"]');
  if (!ogDescTag) {
    ogDescTag = document.createElement("meta");
    ogDescTag.setAttribute("property", "og:description");
    document.head.appendChild(ogDescTag);
  }
  ogDescTag.content = description;

  // Update or create og:title meta tag
  let ogTitleTag = document.querySelector('meta[property="og:title"]');
  if (!ogTitleTag) {
    ogTitleTag = document.createElement("meta");
    ogTitleTag.setAttribute("property", "og:title");
    document.head.appendChild(ogTitleTag);
  }
  ogTitleTag.content = title;
};

export const getMetaTagContent = (name) => {
  const tag = document.querySelector(`meta[name="${name}"]`);
  return tag ? tag.content : "";
};
